import { render, staticRenderFns } from "./inActiveDrivers.vue?vue&type=template&id=ce7caaae"
import script from "./inActiveDrivers.vue?vue&type=script&lang=js"
export * from "./inActiveDrivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports